import { FC, ReactNode } from 'react';
import fieldErrorCss from './assets/field-error.module.scss';

type PropsType = {
  error: ReactNode;
};

const FieldError: FC<PropsType> = ({
  error,
}) => {
  if (!error) {
    return null;
  }

  return (
    <div className={fieldErrorCss.fieldError}>
      {error}
    </div>
  );
};

export { FieldError };
